import { useMutation, useQueryClient } from '@tanstack/react-query';
import recoveryMessagesService from 'v2/services/recoveryMessages';
import type { RecoveryMessage } from 'v2/services/recoveryMessages';

interface UpdateRecoveryMessageParams {
  productId: number;
  messageId: number;
  data: Partial<RecoveryMessage>;
}

export function useUpdateRecoveryMessage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ productId, messageId, data }: UpdateRecoveryMessageParams) =>
      recoveryMessagesService.update(productId, messageId, data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['recoveryMessages', variables.productId] });
    }
  });
}
